export default {"src":"/_next/static/media/hatGlass.e7d5e140.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};